/**
 * FooterWithChildren Component
 *
 * A flexible footer component that can contain action buttons, navigation links,
 * or any custom content. Designed to be sticky at the bottom of the viewport.
 */

import React from "react";
import { FooterWithChildrenProps } from "./types";
import { defaultTheme } from "./themes";
import { mergeTheme } from "../utils/theme";

export const FooterWithChildren: React.FC<FooterWithChildrenProps> = ({
  children,
  position = "sticky",
  backgroundColor = "white",
  borderTop = true,
  padding = "medium",
  className = "",
  theme,
  ...props
}) => {
  const mergedTheme = mergeTheme(defaultTheme, theme);

  const footerClasses = [
    mergedTheme.base,
    mergedTheme.positions?.[position],
    mergedTheme.backgrounds?.[backgroundColor],
    mergedTheme.paddings?.[padding],
    borderTop && mergedTheme.borderTop,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <footer className={footerClasses} {...props}>
      <div className={mergedTheme.container}>{children}</div>
    </footer>
  );
};
